<template>
    <div class="mainTabs-wrapper">
        <div v-show="isZeepliveBoxVisible">
            <div id="parentTabIn" class="parentTabIn">
                <span class="backArrowIcon" id="close" @click="viewClose('someStatus')">
                    <img :src='downArrow' alt="Back Arrow" />
                </span>
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'charmTab' }"
                            @click="activateTab('charmTab')" data-toggle="tab" href="#charmTab" role="tab">Top Charm
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'richTab' }"
                            @click="activateTab('richTab')" data-toggle="tab" href="#richTab" role="tab">Top Rich</div>
                    </li>
                    <li class="nav-item" style="display: none;">
                        <div class="nav-link" :class="{ 'active': activeTab === 'roomTab' }"
                            @click="activateTab('roomTab')" data-toggle="tab" href="#roomTab" role="tab">Top Room</div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'callTab' }"
                            @click="activateTab('callTab')" data-toggle="tab" href="#callTab" role="tab">Top Call</div>
                    </li>
                    <li class="nav-item" style="display: none">
                        <div class="nav-link" :class="{ 'active': activeTab === 'agencyTab' }"
                            @click="activateTab('agencyTab')" data-toggle="tab" href="#agencyTab" role="tab">Top Agency
                        </div>
                    </li>
                    <!-- <li class="nav-item">
                        <div id="rankRewardInfoTab" @click="showRankRewardInfoTab">
                            <div class="header-infoIcon"><img :src='infoIcon' alt="Info Icon" /></div>
                        </div>
                    </li> -->
                </ul>
                <div id="rankRewardInfoTab" @click="showRankRewardInfoTab">
                    <div class="header-infoIcon"><img :src='infoIcon' alt="Info Icon" /></div>
                </div>
            </div>
            <div class="tab-content">
                <div class="tab-pane" :class="{ 'active': activeTab === 'charmTab' }" id="charmTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedCharmTab">
                        <Charm />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'richTab' }" id="richTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedRichTab">
                        <Rich />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'roomTab' }" id="roomTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedRoomTab">
                        <Room />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'callTab' }" id="callTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedCallTab">
                        <Call />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'agencyTab' }" id="agencyTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedAgencyTab">
                        <Agency />
                    </div>
                </div>
            </div>
        </div>
        <div id="rankRewardInfoTab" v-show="isRankRewardInfoTabVisible">
            <div class="tab-contentIn">
                <div class="">
                    <div class="headerWrapper rankRewardTopSec">
                        <div id="goParentTab" @click="activateTab('charmTab')" class="backArrowIcon">
                            <img :src='downArrow' alt="Back Arrow" />
                        </div>
                        <div class="rankingReward-HD">Ranking Rewards</div>
                    </div>
                    <div class="rankRewardContSec" v-if="isLoadedRankRewardInfoTab">
                        <RankRewardInfoComponent :currentTab="activeTab" @tab-changed="handleTabChange" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import downArrow from '../../assets/images/back-blackArrow.svg';
import infoIcon from '../../assets/images/infoIcon.png';
import Charm from '../Charm/CharmCompTab.vue';
import Rich from '../Rich/RichCompTab.vue';
import Room from '../Room/RoomCompTab.vue';
import Call from '../Call/CallCompTab.vue';
import Agency from '../Agency/AgencyCompTab.vue';
import RankRewardInfoComponent from '../RankRewardInfoComponent/RankRewardInfoComponent.vue'
export default {
    name: 'ParentTabComponent',
    components: {
        Charm,
        Rich,
        Room,
        Call,
        Agency,
        RankRewardInfoComponent
    },
    data() {
        return {
            activeTab: 'charmTab',
            isZeepliveBoxVisible: true,
            isRankRewardInfoTabVisible: false,
            downArrow: downArrow,
            infoIcon: infoIcon,
            isLoadedCharmTab: false,
            isLoadedRichTab: false,
            isLoadedRoomTab: false,
            isLoadedCallTab: false,
            isLoadedAgencyTab: false,
            isLoadedRankRewardInfoTab: false
        };
    },
    mounted() {
        this.isLoadedCharmTab = true;
    },
    methods: {
        showRankRewardInfoTab() {
            this.isRankRewardInfoTabVisible = true;
            this.isZeepliveBoxVisible = false;
            //this.activeTab = ''
            this.isLoadedRankRewardInfoTab = true
        },
        hideRankRewardInfoTab() {
            this.isRankRewardInfoTabVisible = false;
            this.isZeepliveBoxVisible = true
            this.isLoadedRankRewardInfoTab = false
        },
        activateTab(tabId) {
            this.isRankRewardInfoTabVisible = false;
            this.isZeepliveBoxVisible = true
            this.activeTab = tabId;
            if (tabId === 'charmTab' && !this.isLoadedCharmTab) {
                this.isLoadedCharmTab = true;
            }
            if (tabId === 'richTab' && !this.isLoadedRichTab) {
                this.isLoadedRichTab = true;
            }
            if (tabId === 'roomTab' && !this.isLoadedRoomTab) {
                this.isLoadedRoomTab = true;
            }
            if (tabId === 'callTab' && !this.isLoadedCallTab) {
                this.isLoadedCallTab = true;
            }
            if (tabId === 'agencyTab' && !this.isLoadedAgencyTab) {
                this.isLoadedAgencyTab = true;
            }

        },
        handleTabChange(tabId) {
            this.activeTab = tabId;
        },

        //Close Webview on back arrow click
        viewClose(status) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                Android.viewClose(status);
            }
        }
    }
}
</script>